<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="add"
          >晒单审核配置</el-button
        >
      </div>
      <div>

        <el-select 
         v-model="typeCode"
         size="small"
         clearable
         placeholder="请选择晒单类型"
         style="margin-right: 10px;">
          <el-option
            label="服务评价"
            value="serviceReservationScoreConfig" 
            >
          </el-option>
          <el-option
            label="商品评价"
            value="orderScoreConfig" 
            >
          </el-option>
          <el-option
            label="服务体验"
            value="serviceItemScoreConfig" 
            >
          </el-option>
        </el-select>


        <el-input
          clearable
          v-model.trim="searchCondition.queryGoodsKey"
          placeholder="请输入商品名称/货号/条码搜索"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          v-model="searchCondition.applyDate"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          align="right"
          start-placeholder="請选择晒单时间段"
          end-placeholder="請选择晒单时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="mb10">
      <el-radio-group
        v-model="searchCondition.queryState"
        size="small"
        @change="switchTabs"
      >
        <el-radio-button label="waitAudit"
          >待审核({{ stateCount.waitAuditNum }})</el-radio-button
        >
        <el-radio-button label="agree"
          >同意({{ stateCount.agreeNum }})</el-radio-button
        >
        <el-radio-button label="refuse"
          >驳回({{ stateCount.refuseNum }})</el-radio-button
        >
        <el-radio-button label="all"
          >全部({{ stateCount.allNum }})</el-radio-button
        >
      </el-radio-group>
    </div>
    <div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditState"
          label="审核状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.auditState === 'waitAudit'" class="blue">
              待审核
            </div>
            <div
              v-if="
                scope.row.auditState === 'agreeUpOnline' ||
                  scope.row.auditState === 'downOnline'
              "
              class="success"
            >
              已通过
            </div>
            <div v-if="scope.row.auditState === 'refuse'" class="danger">
              已驳回
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditState"
          label="上下架状态"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.auditState === 'agreeUpOnline'"
              class="success"
            >
              上架
            </div>
            <div v-if="scope.row.auditState === 'downOnline'" class="danger">
              下架
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员电话号码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="showTime"
          width="140px"
          label="晒单时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          label="关联商品"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="showTitile"
          label="晒单标题"
        >
          <template slot-scope="scope">
            <div class="primary">{{ scope.row.showTitile }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="showContent"
          label="晒单内容"
        >
          <template slot-scope="scope">
            <el-tooltip
              placement="top"
              :content="scope.row.showContent"
              effect="dark"
            >
              <div class="oneLine primary">{{ scope.row.showContent }}</div>
            </el-tooltip>
            <!-- {{ scope.row.goodsNames }} -->
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardSalePrice"
          label="图/视频"
        >
          <template slot-scope="scope">
            <div class="blue pointer" @click="toDetails(scope.row)">
              点击查看详情
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditName"
          label="审核人"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="auditTime"
          label="审核时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="code"
          label="晒单类型"
        >
        <template slot-scope="scope">
          <p v-if="scope.row.code == 'serviceReservationScoreConfig'">服务评价</p>
          <p v-else-if="scope.row.code == 'serviceItemScoreConfig'">服务体验</p>
          <p v-else-if="scope.row.code == 'posOrderScoreConfig'">线下评价</p>
          <p v-else>商品评价</p>
        </template>
        </el-table-column>



        <el-table-column
          header-align="center"
          align="center"
          prop="code"
          v-if="searchCondition.queryState == 'agree'"
          label="回复状态"
        >
        <template slot-scope="scope">
          <p v-if="scope.row.commentStatus == '未回复'" style="color:#56abee;">{{scope.row.commentStatus}}</p>
          <p v-if="scope.row.commentStatus == '已撤销'" style="color:#ff0000">{{scope.row.commentStatus}}</p>
          <p v-if="scope.row.commentStatus == '已回复'" style="color: #2fc348;">{{scope.row.commentStatus}}</p>
        </template>
        </el-table-column>




        <el-table-column
          width="200"
          header-align="center"
          align="center"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <div v-if="scope.row.auditState === 'waitAudit'">
                <el-button
                  class="success"
                  size="small"
                  type="text"
                  @click="audit(scope.row)"
                  >同意</el-button
                >
                <el-button
                  class="danger"
                  size="small"
                  type="text"
                  @click="refuse(scope.row)"
                  >驳回</el-button
                >
              </div>
              <div
                v-if="
                  scope.row.auditState === 'agreeUpOnline' ||
                    scope.row.auditState === 'downOnline'
                "
              >
                <el-button
                  size="small"
                  type="text"
                  :class="
                    scope.row.auditState === 'agreeUpOnline'
                      ? 'danger'
                      : 'success'
                  "
                  @click="upDown(scope.row, scope.row.auditState)"
                  >{{
                    scope.row.auditState === "agreeUpOnline" ? "下架" : "上架"
                  }}</el-button
                >
              </div>

              <div
                v-if="searchCondition.queryState == 'agree'"
              >
                <el-button
                  size="small"
                  type="text"
                  :class="
                    scope.row.commentStatus === '已回复'
                      ? 'danger'
                      : 'success'
                  "
                  @click="replyToTheAction(scope.row, scope.row.commentStatus)"
                  >{{
                    scope.row.commentStatus === "已回复" ? "回复撤销" : "评论回复"
                  }}</el-button
                >
              </div>

            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="1000px"
    >
      <div v-show="type === 'add'">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="136px"
        >
          <el-form-item label="自动审核" prop="audit">
            <el-switch
              v-model="ruleForm.audit"
              size="mini"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="yes"
              active-text="开启"
              inactive-text="关闭"
              inactive-value="no"
            >
            </el-switch>
            <div class="form-item-tip">
              若开启自动审核，则默认所有提交的晒单都审核通过
            </div>
          </el-form-item>
          <el-form-item label="好评反劵" prop="goodCommentCoupon">
            <el-switch
              v-model="ruleForm.goodCommentCoupon"
              size="mini"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="yes"
              active-text="开启"
              inactive-text="关闭"
              inactive-value="no"
            >
            </el-switch>
            <div class="form-item-tip">
              若开启好评返券，则配置要送的礼券，审核通过时送券
            </div>
          </el-form-item>
          <el-form-item label="晒单主页广告上传" prop="advertisingImgs">
            <div class="flex upload-upload-btn">
              <div
                class="btn flex flex-column flex-center open-file"
                v-if="ruleForm.advertisingImgs.length < 6"
                @click="show = true"
              >
                <div class="add-wrapper">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span>上传广告图</span>
              </div>
              <div class="flex flex-column flex-end">
                <div class="tips">只能上传jpg/png文件，且不能超过1MB</div>
                <div class="tips">建议广告图尺寸为690x280</div>
              </div>
            </div>
            <ul class="flex flex-wrap mt10">
              <li
                class="priview mr10"
                v-show="v"
                v-for="(v, i) in ruleForm.advertisingImgs"
                :key="i"
              >
                <!-- <el-image
                    :src="ruleForm.advertisingImgs"
                    :preview-src-list="[ruleForm.advertisingImgs]"
                  >
                  </el-image> -->
                <!-- <img :src="v" alt="logo" /> -->
                <el-image
                  style="height: 100%"
                  :src="v"
                  :preview-src-list="ruleForm.advertisingImgs"
                ></el-image>
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove(i)"
                    >删除</el-button
                  >
                </div>
              </li>
            </ul>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="submitForm('ruleForm')" size="small" type="primary"
            >确 认</el-button
          >
          <el-button @click="handleClose" size="small">取 消</el-button>
        </span>
      </div>
      <ul class="info-list" v-show="type === 'details'">
        <li class="mb20" v-if="picList.length">
          <div class="title">晒单图片</div>
          <div class="flex flex-wrap mb10">
            <el-image
              class="mr10"
              v-for="(v, i) in picList"
              :key="i"
              style="width:200px;height: 200px"
              :src="v"
              :preview-src-list="picList"
            ></el-image>
          </div>
        </li>
        <li class="mb20" v-if="videoList.length">
          <div class="title">晒单视频</div>
          <div class="flex flex-wrap mr10">
            <video
              v-for="(v, i) in videoList"
              :key="i"
              :src="v.relValue"
              :poster="v.aviPoster"
              controls
              class="video"
              width="200px"
            >
              您的浏览器不支持播放。
            </video>
          </div>
        </li>
      </ul>
    </el-dialog>
    <my-upload
      field="file"
      @crop-upload-success="cropUploadSuccess"
      v-model="show"
      noCircle
      noSquare
      :width="690"
      :height="280"
      :headers="{ 'X-Access-Token': $token }"
      :params="{ fileDir: 'goodsCenter' }"
      :url="$uploadUrl"
      img-format="png"
    ></my-upload>
    <el-dialog
      title="选择券包"
      :visible="passVisible"
      @close="passVisible = false"
      custom-class="sales-volumn-dialog"
    >
      <el-form
        label-width="80px"
        :model="ruleFormPass"
        :rules="rulesPass"
        ref="ruleFormPass"
      >
        <el-form-item label="选择券包" prop="sendId">
          <el-select
            clearable
            v-model="ruleFormPass.sendId"
            placeholder="选择券包"
            size="small"
            filterable
            class="mr10"
          >
            <el-option
              v-for="(item, i) in couponSendList"
              :key="i"
              :label="item.name"
              :value="item.couponSendId"
            ></el-option>
          </el-select>
          <div class="form-tip">
            请先在优惠券发放中设置发放类型为“活动发放"的优事券包，方可直接给用户发放优惠券包
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="pass('ruleFormPass')" size="small" type="success"
          >确认发放</el-button
        >
      </span>
    </el-dialog>



    <el-dialog
    title="回复客户评价"
    :visible.sync="isRespondToCustomers"
    width="600px"
    >

    <div class="respondToReviews">

      <div class="evaluationInformation">
        <h5>评价信息</h5>
        <div class="main">
          <div class="item">
            <div class="lable">
              会员手机号
            </div>
            <p>{{ reviewResponsesRow.memberMobile }}</p>
          </div>
          <div class="item">
            <div class="lable">
              晒单标题
            </div>
            <p>{{ reviewResponsesRow.showTitile }}</p>
          </div>
        </div>

      </div>

      <h5 style="margin: 30px 0 20px 0;">评价内容</h5>

      <div class="content">
        {{ reviewResponsesRow.showContent }}
      </div>

      <h5 style="margin: 30px 0 20px 0;">晒单图片</h5>

      <div class="img_box" v-if="reviewResponsesRow.imgList && reviewResponsesRow.imgList.length > 0">
        <img v-for="(v, index) in reviewResponsesRow.imgList" :key="index" :src="v">
      </div>


      <h5 style="margin: 30px 0 20px 0;">回复内容</h5>
      <div class="reply_to_the_content" style="margin-bottom: 20px;">
        <p v-for="(v, index) in reviewResponsesRow.quickReplyList" @click="showContent=v" :key="index">{{ v }}</p>
      </div>


      <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4}"
        show-word-limit
        maxlength="200"
        placeholder="请输入内容"
        v-model="showContent">
      </el-input>




    </div>



    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="isRespondToCustomers = false">取 消</el-button>
      <el-button size="small" type="primary" @click="commentReplies">确 定</el-button>
    </span>
</el-dialog>




  </hm-content>
</template>

<script>
import myUpload from "vue-image-crop-upload";
export default {
  components: { myUpload },
  data() {
    return {
      type: "",
      showContent:'',
      isRespondToCustomers:false,
      typeCode:'',
      show: false,
      passVisible: false,
      ruleFormPass: {
        sendId: ""
      },
      rulesPass: {
        sendId: {
          required: true,
          message: "请选择卷包",
          trigger: "change"
        }
      },
      ruleForm: {
        audit: "",
        goodCommentCoupon: "",
        advertisingImgs: []
      },
      rules: {
        audit: {
          required: true,
          message: "请选择是否开启",
          trigger: "change"
        },
        goodCommentCoupon: {
          required: true,
          message: "请选择是否开启",
          trigger: "change"
        },
        advertisingImgs: {
          required: true,
          message: "请上传广告图",
          trigger: "change"
        }
      },
      searchCondition: {
        queryState: "waitAudit"
      },
      title: "",
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      list: [],
      total: 0,
      reviewResponsesRow:[],
      stateCount: {},
      detailConfigList: [],
      detailsList: [],
      picList: [],
      rowData: {},
      videoList: [],
      couponSendList: [],
      row: {}
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
    this.queryCouponList();
  },
  methods: {
    async commentReplies(){
      if(!this.showContent){
        this.$message.error('请输入回复内容')
        return;
      }

     const {code} = await this.$store
        .dispatch("storeMemberShowReplyInfoAdd", {
          showId: this.reviewResponsesRow.showId,
          centerId: this.rowData.centerId,
          showContent: this.showContent
        })
      if (code == 0) {
        this.$message.success("回复成功");
        this.isRespondToCustomers = false;
        this.queryList();
      }
    },
    // 回复操作
    async replyToTheAction(row, commentStatus) {
      console.log(commentStatus);
      console.log(row);
      if(commentStatus == '已回复'){
        const { result } = await this.$store.dispatch(
        "hideReplyByShowId",
        {
          replyId: row.replyId,
          commentStatus: 'revoke'
        });

        this.$message.success('撤销成功');
        this.queryList();
        return;
      }
      this.rowData = row;
      this.showContent = '';
      const { result } = await this.$store.dispatch(
        "findMemberShowComment",
        {
          showId: row.showId
        }
      );
      const imgList = result.relModelList.map(e=>{
        let arrs=[];
        if(e.relType == 'pic'){
          arrs.push(e.relValue)
        }
        return arrs;
      })
      result.imgList = imgList;
      this.reviewResponsesRow = result;
      this.isRespondToCustomers = true;
    },
    async upDown(row, auditState) {
      let name =
        auditState === "agreeUpOnline" ? "downOnline" : "agreeUpOnline";
      this.handle(row.showId, name);
    },
    resetFormPass() {
      setTimeout(() => {
        this.$refs.ruleFormPass.resetFields();
      }, 0);
    },
    async pass(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = JSON.parse(JSON.stringify(this.row));

        Object.assign(params, this.ruleFormPass);
        params.state = "1";

        this.$store.dispatch("updateMarketCheck", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.resetFormPass();

            this.dialogVisible = false;
            this.passVisible = false;
            this.queryList();
          }
        });
      } else {
        return false;
      }
    },
    async queryCouponList() {
      let params = {
        storeCode: this.row.storeCode
      };

      const { result } = await this.$store.dispatch(
        "findCouponSendList",
        params
      );
      this.couponSendList = result;
    },
    async handle(showId, auditState) {
      let params = {
        showId,
        auditState
      };
      const { code, result } = await this.$store.dispatch(
        "editMemberShowState",
        params
      );
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.dialogVisible = false;
        this.queryList();
        if (auditState === "agreeUpOnline") {
          if (result) {
            this.passVisible = true;
          }
        }
      }
    },
    audit(row) {
      this.row = row;
      this.handle(row.showId, "agreeUpOnline");
    },
    refuse(row) {
      this.$confirm("是否驳回?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.handle(row.showId, "refuse");
      });
    },
    async toDetails(row) {
      this.title = "详情";
      this.type = "details";
      this.dialogVisible = true;
      const { result } = await this.$store.dispatch("queryMemberShowDetails", {
        showId: row.showId
      });
      this.detailsList = result;
      this.picList = [];
      this.videoList = [];
      this.detailsList.forEach(v => {
        if (v.relType === "pic") {
          this.picList.push(v.relValue);
        } else {
          this.videoList.push({ relValue: v.relValue, aviPoster: v.aviPoster });
        }
      });
    },
    async queryDetailConfig() {
      let params = {
        code: "memberShowConfig"
      };
      const { result } = await this.$store.dispatch(
        "queryMemberShowScoreConfigList",
        params
      );
      this.detailConfigList = result;

      result.forEach(v => {
        if (v.type === "advertisingImgs") {
          if (v.value === "") {
            this.ruleForm[v.type] = [];
          } else {
            this.ruleForm[v.type] =
              v.value.indexOf(",") !== "-1" ? v.value.split(",") : v.value;
          }
        } else {
          this.ruleForm[v.type] = v.value;
        }
      });
    },
    // 移除上传文件
    handleRemove(i) {
      this.ruleForm.advertisingImgs.splice(i, 1);
    },
    handleClose() {
      this.dialogVisible = false;
      this.resetRuleForm();
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
      }, 0);
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = [];

        this.detailConfigList.forEach(v => {
          if (v.type === "advertisingImgs") {
            v.value =
              this.ruleForm[v.type].length > 1
                ? this.ruleForm[v.type].join(",")
                : this.ruleForm[v.type][0];
          } else {
            v.value = this.ruleForm[v.type];
          }
          params.push({
            configId: v.configId,
            value: v.value,
            helpText: v.helpText,
            code: v.code
          });
        });

        const { code } = await this.$store.dispatch(
          "editMemberShowConfigList",
          { memberShowConfigList: params }
        );
        if (code === "0") {
          this.$message({
            type: "success",
            message: "操作成功"
          });
          this.dialogVisible = false;
          this.queryList();
        }
      }
    },
    cropUploadSuccess(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.advertisingImgs.push(jsonData.result);

        if (this.ruleForm.advertisingImgs.length >= 6) {
          setTimeout(() => {
            this.show = false;
          }, 0);
        }
      }
    },

    add() {
      this.dialogVisible = true;
      this.type = "add";
      this.title = "晒单审核配置";
      this.queryDetailConfig();
    },
    switchTabs(val) {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {
      let params = {
        code: this.typeCode,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.endTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryMemberShowAuditList",
        params
      );
      const { pageList, stateCount } = result;
      this.list = pageList.records;
      this.total = pageList.total;
      this.stateCount = stateCount;
    }
  }
};
</script>
<style lang="scss" scoped>

.respondToReviews {
  background: #fff;
  h5 {
    font-size: 14px;
    color: #333;
    margin: 0;
  }
  .evaluationInformation {
    width: 100%;
    background: #f9fafb;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 10px;
   
    .main {
      display: flex;
      align-items: center;
      margin-top: 20px;
      .item {
        width: 50%;
        p {
          color: #333;
          font-weight: 600;
          margin-top: 6px;
        }
      }
    }
    
  }
  .content {
    width: 100%;
    background: #f9fafb;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 10px;
  }
  .img_box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      img {
        width: 32%;
        height: 100px;
        border-radius: 12px;
        margin-right: 1%;
        object-fit: cover;
        margin-bottom: 10px;
      }
  }
  .reply_to_the_content {
    p {
      background: #f3f4f6;
      color: #333;
      border-radius: 4px;
      padding: 5px 10px;
      display: inline-block;
      margin-right: 10px;
      cursor: pointer;
      margin-bottom: 10px;
    }
  }
}


.oneLine {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info-list,
.logistics-list {
  .title {
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.priview {
  position: relative;
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
</style>
